// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"123":"4c64ffb53023580f94f1","388":"76ab4740ccb222145b57","696":"ef669e86ac5c7c0d6ade","756":"572268d4223bbeed80fa"}[chunkId] + ".js";
};